const blocks = document.querySelectorAll(
  ".wp-block-portal-za-zenske-newsletter-input"
);

if (blocks.length) {
  import("./view-frontend.js").then(({ initBlock }) => {
    blocks.forEach((block) => initBlock(block));
  });
}
